import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=090b7eee&scoped=true&"
import script from "./ButtonWidget.vue?vue&type=script&lang=js&"
export * from "./ButtonWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b7eee",
  null
  
)

export default component.exports